import QRCodeUsageHistoryDisplay from './QRCodeUsageHistoryDisplay'

export default QRCodeUsageHistoryDisplay